import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { animate, style, transition, trigger } from "@angular/animations";

/**
 * LoginHeroComponent — pannello destro "login style" con onde brand-gradient
 * animate e le 4 bubbles fluttuanti del metodo 4H (Heart/Head/Hands/Results),
 * con caption su hover.
 *
 * Riusato da:
 *  - LoginShellComponent (login admin/cliente)
 *  - PublicCompileComponent (schermate loading/blocked/rate-limit)
 *
 * È un componente puramente presentazionale: nessun @Input, nessuna logica
 * di business. Le classi sono `login-shell__*` / `login-shell__bubble*` per
 * preservare la selettività CSS preesistente (cfr. login-shell.component.scss).
 */
@Component({
  selector: "app-login-hero",
  templateUrl: "./login-hero.component.html",
  styleUrls: ["./login-hero.component.scss"],
  animations: [
    trigger("captionFade", [
      transition(":enter", [
        style({ opacity: 0, transform: "scale(0.9)", filter: "blur(6px)" }),
        animate(
          "380ms cubic-bezier(0.22,1,0.36,1)",
          style({ opacity: 1, transform: "scale(1)", filter: "blur(0)" })
        ),
      ]),
      transition(":leave", [
        animate(
          "380ms cubic-bezier(0.22,1,0.36,1)",
          style({ opacity: 0, transform: "scale(0.9)", filter: "blur(6px)" })
        ),
      ]),
    ]),
  ],
})
export class LoginHeroComponent {
  hoveredBubble: string | null = null;

  bubbleTexts: Record<string, string> = {
    heart: "Lo straordinario viaggio che ti allinea alla tua impresa.",
    head: "La strategia da cui prende forma la vera espansione.",
    hands: "“Tu e le tue Persone”: la concretezza dell’azione.",
    results:
      "È il cerchio che si chiude, l’auto-evoluzione della tua impresa.",
  };

  /** Easter egg: 10 click sulla bubble "results" aprono il login admin. */
  private resultsClicks = 0;

  constructor(private router: Router) {}

  onResultsClick(): void {
    this.resultsClicks += 1;
    if (this.resultsClicks >= 10) {
      this.resultsClicks = 0;
      this.router.navigate(["/admin/login"]);
    }
  }
}
